/**
 * The level at which a user holds a permission, by the SAME rule the server's PermissionMiddleware::userHas
 * applies (Wave B #18, 2026-10-16): only ACTIVE grants count, and the highest of them wins. 0 = not held.
 *
 * The screens used to take the FIRST grant with the name and ignore its status. A person can hold the same
 * permission twice (once from their role, once added by hand), so a manager who lowered or switched off one
 * grant saw no change on screen; and someone whose access really was switched off still saw every button,
 * which the server then refused.
 */
export function activePermissionLevel(permissionUsers: any[] | null | undefined, name: string): number {
  const wanted = (name || '').toUpperCase();
  return (permissionUsers || [])
    .filter((pu: any) => (pu?.permission?.name || '').toUpperCase() === wanted && (pu?.status || '').toUpperCase() === 'ACTIVE')
    .filter((pu: any) => permissionIsOn(pu?.permission))
    .reduce((max: number, pu: any) => Math.max(max, Number(pu.permission_level) || 0), 0);
}

/**
 * The permission itself must be switched on and not deleted (#140, 2026-10-27), as the server now requires. A permission
 * that arrives with no status at all (an older payload) is taken as on, rather than locking someone out on a guess.
 */
function permissionIsOn(permission: any): boolean {
  if (permission?.date_deleted) {
    return false;
  }
  const status = (permission?.status ?? '').toString().toUpperCase();

  return status === '' || status === 'ACTIVE';
}
